import { defineStore } from 'pinia'
import { fetchWrapper } from '@/helpers/fetch-wrapper';
import { ref } from 'vue'

const baseUrl = `${import.meta.env.VITE_BASE_URL}`;

export const useTasksStore = defineStore('tasks', () => {
  const activeTasks = ref([])
  const newTasks = ref([])
  const completedTasks = ref([])
  const pendingChecksTasks = ref([])
  const towns = ref([])
  const marketplaces = ref([])



  async function fetchActiveTasks(query = null) {
    let url = new URL(`${baseUrl}/tasks/active/`)
    url.searchParams.set('limit', '100000')
    if (query != null) {
      try {
        query.forEach((value, key) => url.searchParams.set(key, value))
      } catch (err) {
        console.log(err)
      }
    }
    return new Promise((resolve, reject) => {
      fetchWrapper.get(new String(url)).then((result) => {
        const results = result?.results
        activeTasks.value = results
        resolve(results)
      }).catch((error) => {
        reject(error)
      });
    })
  }
  async function fetchNewTasks(query = null) {
    let url = new URL(`${baseUrl}/tasks/new/`)
    url.searchParams.set('limit', '100000')
    if (query != null) {
      try {
        query.forEach((value, key) => url.searchParams.set(key, value))
      } catch (err) {
        console.log(err)
      }
    }
    return new Promise((resolve, reject) => {
      fetchWrapper.get(new String(url)).then((result) => {
        const results = result?.results
        newTasks.value = results
        resolve(results)
      }).catch((error) => {
        reject(error)
      });
    })
  }
  async function fetchCompletedTasks(query = null) {
    let url = new URL(`${baseUrl}/tasks/completed/`)
    url.searchParams.set('limit', '100000')
    if (query != null) {
      try {
        query.forEach((value, key) => url.searchParams.set(key, value))
      } catch (err) {
        console.log(err)
      }
    }
    return new Promise((resolve, reject) => {
      fetchWrapper.get(new String(url)).then((result) => {
        const results = result?.results
        completedTasks.value = results
        resolve(results)
      }).catch((error) => {
        reject(error)
      });
    })
  }
  async function fetchPendingChecksTasks(query = null) {
    let url = new URL(`${baseUrl}/tasks/pending_checks/`)
    url.searchParams.set('limit', '100000')
    if (query != null) {
      try {
        query.forEach((value, key) => url.searchParams.set(key, value))
      } catch (err) {
        console.log(err)
      }
    }
    return new Promise((resolve, reject) => {
      fetchWrapper.get(new String(url)).then((result) => {
        const results = result?.results
        pendingChecksTasks.value = results
        resolve(results)
      }).catch((error) => {
        reject(error)
      });
    })
  }

  async function completeTask(taskId, formData) {
    return new Promise((resolve, reject) => {
      fetchWrapper.patchFormData(`${baseUrl}/tasks/${taskId}/complete/`, formData).then(() => {
        activeTasks.value = activeTasks.value.filter((item) => { return item.id !== taskId })
        newTasks.value = newTasks.value.filter((item) => { return item.id !== taskId })
        resolve('ok')
      }).catch((error) => {
        reject(error)
      });
    }
    )
  }

  async function takeTask(taskId) {
    return new Promise((resolve, reject) => {
      fetchWrapper.patch(`${baseUrl}/tasks/${taskId}/take/`, {}).then((updatedTask) => {
        console.log(updatedTask)
        const results = newTasks.value
        const taskIndex = results.findIndex(task => task.id === taskId)
        results[taskIndex] = updatedTask
        newTasks.value = Array.from(results)
        // newTasks.value = newTasks.value.filter((item) => { return item.id !== taskId })
        resolve('ok')
      }).catch((error) => {
        if (error.state === 404) {
          newTasks.value = newTasks.value.filter((item) => { return item.id !== taskId })
        }
        reject(error)
      });
    }
    )
  }

  async function checkTask(taskId) {
    return new Promise((resolve, reject) => {
      fetchWrapper.patch(`${baseUrl}/tasks/${taskId}/check/`, {}).then(() => {
       pendingChecksTasks.value = pendingChecksTasks.value.filter((item) => { return item.id !== taskId })
        resolve('ok')
      }).catch((error) => {
        if (error.status === 404 ){ 
          pendingChecksTasks.value = pendingChecksTasks.value.filter((item) => { return item.id !== taskId })
          resolve('ok')
        }
        reject(error)
      });
    }
    )
  }
  async function fetchTowns(query = null) {
    let url = new URL(`${baseUrl}/towns/`)
    url.searchParams.set('limit', '100000')
    if (query != null) {
      try {
        query.forEach((value, key) => url.searchParams.set(key, value))
      } catch (err) {
        console.log(err)
      }
    }
    return new Promise((resolve, reject) => {
      fetchWrapper.get(new String(url)).then((result) => {
        const results = result?.results
        towns.value = results
        resolve(results)
      }).catch((error) => {
        reject(error)
      });
    })
  }
  async function fetchMarketplaces(query = null) {
    let url = new URL(`${baseUrl}/marketplaces/`)
    url.searchParams.set('limit', '100000')
    if (query != null) {
      try {
        query.forEach((value, key) => url.searchParams.set(key, value))
      } catch (err) {
        console.log(err)
      }
    }
    return new Promise((resolve, reject) => {
      fetchWrapper.get(new String(url)).then((result) => {
        const results = result?.results
        marketplaces.value = results
        resolve(results)
      }).catch((error) => {
        reject(error)
      });
    })
  }
  return {
    activeTasks,
    newTasks,
    completedTasks,
    pendingChecksTasks,
    towns,
    marketplaces,
    fetchActiveTasks,
    fetchNewTasks,
    fetchCompletedTasks,
    fetchPendingChecksTasks,
    completeTask,
    takeTask,
    checkTask,
    fetchTowns,
    fetchMarketplaces,
  }
})
